<template>
  <div >
    <transition name="new" mode="out-in" appear>
      <ViewMore
        class="tw-py-6"
        v-if="notifications.length > 0"
        :limit="8"
        :list="notifications"
        v-slot="{ item: notification }"
      >
        <div
          :class="[
            'mr-body tw-flex tw-py-4',
            { 'hover:tw-bg-gray-200 transition-fast' : actionIsValid(notification.action1) }
          ]"
        >
          <div class="tw-w-1/4 tw-flex-shrink-0">
            <!-- ADD IMAGE/ICON -->
          </div>
          <div class="tw-w-3/4 tw-pl-3 tw-flex-shrink-0 tw-relative">
            <div class="tw-flex tw-flex-no-wrap">
              <div class="tw-flex-grow">
                <template v-if="actionIsValid(notification.action1)">
                  <div
                    @click="navigateTo(notification.action1)"
                    class="tw-cursor-pointer"
                    tag="div"
                    :title="notification.type | notificationActionText(1)"
                  >
                    <p style="word-break: break-word;" class="tw-text-sm tw-leading-snug opacity-78 tw-break-words">{{ notification.text_message }}</p>
                    <p class="tw-text-xs leading-14 opacity-54 tw-pt-2">{{ notification.time | moment('MMM DD, YYYY') }}</p>
                  </div>
                </template>
                <template v-else>
                  <p style="word-break: break-word;" class="tw-text-sm tw-leading-snug opacity-78 tw-break-words">{{ notification.text_message }}</p>
                  <p class="tw-text-xs leading-14 opacity-54 tw-pt-2">{{ notification.time | moment('MMM DD, YYYY') }}</p>
                </template>
              </div>
              <div class="tw-ml-2 tw-flex tw-items-center">
                <!-- ADD CLOSE BUTTON -->
                <button
                  class="tw-bg-white tw-rounded-l-full tw-p-1 group-hover hover:tw-shadow-app-lg hover:tw-text-blue-800 tw-cursor-pointer tw-fill-current tw-text-black opacity-54"
                  type="button"
                  @click.prevent="markNotificationRead(notification)"
                  v-if="canMarkRead(notification)"
                >
                  <svg version="1.1" class="tw-w-4 tw-h-4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 72 72" style="enable-background:new 0 0 72 72;" xml:space="preserve">
                    <path d="M41.2,36L70.9,6.4c1.5-1.5,1.5-3.8,0-5.2c-1.5-1.5-3.8-1.5-5.2,0L36,30.8L6.4,1.1c-1.5-1.5-3.8-1.5-5.2,0s-1.5,3.8,0,5.2
                      L30.7,36L1.1,65.6c-1.5,1.5-1.5,3.8,0,5.3C1.9,71.6,3,72,3.7,72s1.9-0.4,2.6-1.1L36,41.3l29.6,29.6c0.7,0.8,1.9,1.1,2.6,1.1
                      s1.9-0.4,2.6-1.1c1.5-1.5,1.5-3.8,0-5.3L41.2,36z"/>
                  </svg>
                </button>
              </div>
            </div>
            <div class="tw-flex tw-mt-4 tw-w-full tw-flex-wrap tw-items-start">
              <!-- ADD ACTION BUTTONS -->
              <BaseButton
                v-if="!canMarkRead(notification) && totalActionButtons(notification) === 0"
                @click="navigateTo(notification.action1)"
                :text="notification.type | notificationActionText(1)"
                :class="[
                  'tw-bg-gray-100 hover:tw-bg-gray-400 tw-mb-1',
                  { 'tw-flex-grow tw-mr-8': totalActionButtons(notification) === 0 }
                ]"
              />
              <BaseButton
                v-if="actionIsValid(notification.action2)"
                @click="navigateTo(notification.action2)"
                :text="notification.type | notificationActionText(2)"
                :class="[
                  'tw-bg-gray-100 hover:tw-bg-gray-400 tw-mb-1',
                  { 'tw-flex-grow tw-mr-8': totalActionButtons(notification) === 1 },
                  { 'tw-mr-4': totalActionButtons(notification) > 1 }
                ]"
              />
              <BaseButton
                v-if="actionIsValid(notification.action3)"
                @click="navigateTo(notification.action3)"
                :text="notification.type | notificationActionText(3)"
                :class="[
                  'tw-bg-gray-100 hover:tw-bg-gray-400',
                  { 'tw-flex-grow tw-': totalActionButtons(notification) === 1 },
                ]"
              />
            </div>
          </div>
        </div>
        <div class="tw-w-3/4 tw-ml-auto tw-border-b tw-border-black opacity-11"></div>
      </ViewMore>
      <!-- GOODIES -->
      <p v-else class="tw-py-8 tw-text-center tw-text-sm leading-17 opacity-31">You have no notifications</p>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { cleanUrl } from '@/modules/dataHelper';

export default {
  name: 'NotificationList',
  computed: {
    ...mapGetters([
      'notifications',
    ]),
  },
  methods: {
    // [TODO] Test if action link is valid
    actionIsValid(action = '') {
      return action.length > 1;
    },
    totalActionButtons(notification = {}) {
      return [
        this.actionIsValid(notification.action2),
        this.actionIsValid(notification.action3),
      ].reduce((total, is) => {
        // eslint-disable-next-line no-param-reassign
        const sum = is ? total += 1 : total;
        return sum;
      }, 0);
    },
    canMarkRead(notification) {
      return (/(\S+(read))/.test(notification.type));
    },
    async markNotificationRead(notification) {
      // action
      const response = await this.$store.dispatch('markNotificationRead', notification.id);

      if (!response) {
        this.$toasted.global.appError();
      }
    },
    navigateTo(url) {
      const cleanedUrl = cleanUrl(url);
      window.location.assign(cleanedUrl);
    },
  },
};
</script>

<style>

</style>
